import { useState } from 'react';

/**
 * Local draft state for an edit section. `resetKey` is a stable token (e.g.
 * the venue's `updatedAt`) — when it changes, the draft reseeds from `seed`
 * using React's render-phase reset pattern (no effect, so no reseed loop from
 * the freshly-built `seed` object each render). Returns the draft, a field
 * setter, the raw setter, and a reset-to-seed for Cancel.
 */
export function useFormDraft<T extends object>(seed: T, resetKey: string) {
  const [draft, setDraft] = useState<T>(seed);
  const [appliedKey, setAppliedKey] = useState(resetKey);
  if (appliedKey !== resetKey) {
    setAppliedKey(resetKey);
    setDraft(seed);
  }
  const setField = <K extends keyof T>(key: K, value: T[K]) =>
    setDraft((d) => ({ ...d, [key]: value }));
  const reset = () => setDraft(seed);
  return { draft, setField, setDraft, reset };
}
